import React, { useState, useEffect, forwardRef } from 'react';
import MaterialTable from 'material-table';
import RefreshIcon from '@material-ui/icons/Refresh';
import { useMessage } from "../../context/message";
import { useAuth } from "../../context/auth";
import { useField } from '../../context/context'
import { rangeFilter, dateRangeFilter } from '../FilterFunctions';
import CustomFilter from '../CustomFilter';
import VerticalAlignBottomIcon from '@material-ui/icons/VerticalAlignBottom'
import InfoIcon from '@material-ui/icons/Info'
import InfoDialog from '../display/InfoDialog'

export default function TeamStorageTable() {
  const { setMessage } = useMessage();
  const { auth } = useAuth();
  const { products} = useField()
  const [bounds, setBounds] = useState({});
  const [toggle, fetchData] = useState(false);
  const [data, setData] = useState([]);
  const [listing_id, setListingId] = useState(0)
  const [product_lookup, setProduct_lookup] = useState({});
  const [open, openInfo] = useState(false)

  useEffect(() => {
    fetch('/api/listing/team', {
      method: 'GET',
      headers: {
        'x-access-token': sessionStorage.getItem('token')
      }
    })
    .then(response => auth(response))
    .then(response => {
      setData(response.data || []);
      setBounds && setBounds(response.bounds || {});
    })
    .catch(error => {
      setMessage({type: 'error', text: 'Error! Unable to fetch storage data'});
      console.error('Error:', error);
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [toggle, setMessage, setBounds])

  useEffect(()=> {
    if(products) {
      let temp = {}
      products.map(item => temp[item.product] = item.product)
      setProduct_lookup(temp)
    }
  },[products])

  const columns = [
    {
      title: 'Username',
      field: 'username',
      defaultGroupOrder: 0
    },
    {
      title: 'Listing ID',
      field: 'listing_id',
    },
    {
      title: 'Storage Name',
      field: 'storage_name',
    },
    {
      title: 'Working Capacity (MBBL)',
      field: 'working_capacity',
      type: 'numeric',
      bounds: bounds.working_capacity,
      customFilterAndSearch: rangeFilter('working_capacity'),
    },
    {
      title: 'Shell Price (USD/BBL)',
      field: 'ask_price',
      type: 'numeric',
      bounds: bounds.ask_price,
      customFilterAndSearch: rangeFilter('ask_price'),
    },
    {
      title: 'Term (Months)',
      field: 'term',
      type: 'numeric',
      bounds: bounds.term,
      customFilterAndSearch: rangeFilter('term'),
    },
    {
      title: 'Availability after Commitment (Months)',
      field: 'delay_after_commit',
      type: 'numeric',
      bounds: bounds.delay_after_commit,
      customFilterAndSearch: rangeFilter('delay_after_commit'),
    },
    {
      title: 'Heel Product',
      field: 'heel_product',
      lookup: product_lookup
    },
    {
      title: 'Start Date',
      field: 'date_available',
      type: 'date',
      customFilterAndSearch: dateRangeFilter('date_available'),
      customSort: (a,b) => {
        var date1 = new Date(a.date_available)
        var date2 = new Date(b.date_available)

        return date1 - date2
      },
      render: rowData => <p>{(new Date(rowData.date_available)).toLocaleDateString()}</p>
    },
    {
      title: 'Comment',
      field: 'comment',
      render: rowData => (
        rowData.comment && (rowData.comment.length > 30 ? rowData.comment.substring(0,30) + '...' : rowData.comment)
      )
    },
    {
      title: 'Location Visibility',
      field: 'visibility',
      lookup: {
        0: 'Region Only',
        1: 'State Only',
        2: 'Full Location'
      }
    },
    {
      title: 'Allow Sublet',
      field: 'allow_sublet',
      lookup: {
        0: 'N',
        1: 'Y'
      }
    }
  ];

  const handleCloseInfo = () => {
    openInfo(false)
    setListingId(0)
  }

  return (
    <div>
      <InfoDialog
        open = {open}
        onClose = {handleCloseInfo}
        type = 'listing_info'
        id = {listing_id}
        disablePlaceBid = {true}
      />
      <MaterialTable
        title='Our Listings'
        columns={columns}
        data={data}
        icons={{Export: forwardRef((props, ref) => <VerticalAlignBottomIcon color = 'primary' {...props} ref={ref}/>)}}
        options={{
          filtering: true,
          draggable: false,
          exportButton: false,
          grouping: true
        }}
        components={{
          Groupbar: () => null,
          FilterRow: props => <CustomFilter {...props} />,
        }}
        actions={[
          {
            icon: () => <RefreshIcon color = 'primary'/>,
            tooltip: 'Refresh',
            isFreeAction: true,
            onClick: event => fetchData(!toggle)
          },
          {
            icon: () => <InfoIcon color = 'primary'/>,
            tooltip: 'More Info',
            onClick: (e, rowData) => {
              setListingId(rowData.listing_id)
              openInfo(true)
            }
          }
        ]}
      />
    </div>
  );
}
